import React from 'react'
import { Dialog } from 'primereact/dialog';
import { Button, Spinner } from 'reactstrap';

export const DialogPreviewPdfSamplingSheet = (props) => {

    const {

        showPreviewSamplingSheet, setShowPreviewSamplingSheet, pdfPreviewSamplingSheet, handleDownloadPdf, informationQuatation, loadingPdf, currentCode, currentQuoter
   } = props;

  return (
    <Dialog
        header="Previsualización de PDF "
        visible={showPreviewSamplingSheet}
        style={{ width: '60vw', maxWidth: '700px' }}
        modal
        dismissableMask  
        onHide={() => setShowPreviewSamplingSheet(false)}
        headerStyle={{
        backgroundColor: '#0d3b59',
        color: 'white',
        fontWeight: 'bold',
        }}
        pt={{
        header: { style: { backgroundColor: '#0d3b59', color: 'white' } },
        headerIcon: { style: { color: 'white' } },
        }}
    >
    {pdfPreviewSamplingSheet && (
        <>
            <iframe
                src={pdfPreviewSamplingSheet}
                title="PDF Preview"
                width="100%"
                height="600px"
                style={{ border: "none" }}
            />
            <div style={{ marginTop: '10px', textAlign: 'center' }}>
                <Button
                    className="p-button-primary"
                    style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}
                    onClick={() => handleDownloadPdf(currentQuoter, currentCode)}
                    
                    disabled={loadingPdf}
                >
                    {loadingPdf && <Spinner size="sm" color="light" />} 
                    {loadingPdf ? "Generando PDF..." : "Descargar PDF"}
                </Button>

            </div>
        </>
        )}
    </Dialog>
   
  )
}
